'use strict';

//RA document translation (request/approve translated PDFs)
export const ENABLE_RA_TRANSLATION = false;
